import { useState, useMemo } from 'react';

export const useLeadsFilters = (submissions) => {
  const [q, setQ] = useState('');
  const [country, setCountry] = useState('all');
  const [fit, setFit] = useState('all');
  const [contactedFilter, setContactedFilter] = useState('all');
  const [reportOnly, setReportOnly] = useState(false);

  const countryOptions = useMemo(() => {
    const set = new Set();
    submissions.forEach(s => (s.latest_assessment?.top_countries || []).forEach(tc => set.add(tc.country)));
    return [...set].sort();
  }, [submissions]);

  const fitOptions = useMemo(() => {
    const set = new Set();
    submissions.forEach(s => (s.latest_assessment?.top_countries || []).forEach(tc => set.add(tc.fit)));
    return [...set].sort();
  }, [submissions]);

  const filtered = useMemo(() => submissions.filter(s => {
    if (q && !`${s.full_name} ${s.email}`.toLowerCase().includes(q.toLowerCase())) return false;
    const tcs = s.latest_assessment?.top_countries || [];
    if (country !== 'all' && !tcs.some(tc => tc.country === country)) return false;
    if (fit !== 'all' && !tcs.some(tc => tc.fit === fit)) return false;
    if (contactedFilter === 'yes' && !s.contacted) return false;
    if (contactedFilter === 'no' && s.contacted) return false;
    if (reportOnly && !s.report_requested) return false;
    return true;
  }), [submissions, q, country, fit, contactedFilter, reportOnly]);

  return {
    q, setQ, country, setCountry, fit, setFit,
    contactedFilter, setContactedFilter, reportOnly, setReportOnly,
    countryOptions, fitOptions, filtered,
  };
};
